const HMR_KEY = '__tiny_worker_pool__';
const Q_KEY = '__tiny_worker_queue__';

type WorkerPoolState = { pool: Worker[] };
type WorkerQueueItem = {
  payload: any;
  transfer?: Transferable[];
  resolve: (value: any) => void;
  reject: (err: any) => void;
};

function createWorkers(): Worker[] {
  return Array.from({ length: 4 }, () =>{
    const w = new Worker(new URL('./workerFunction.ts', import.meta.url), { type: 'module' });
    (w as any).busy = false;
    return w;
  });
}

function ensureWorkers(): Worker[] {
  const g = globalThis as any;
  if (!g[HMR_KEY]) g[HMR_KEY] = { pool: createWorkers() } as WorkerPoolState;
  return g[HMR_KEY].pool;
}

const g = globalThis as any;
const workerQueue: WorkerQueueItem[] = g[Q_KEY] ?? (g[Q_KEY] = []);


function workerProcess() {
  const pool = ensureWorkers();
  const worker = pool.find((w) => !(w as any).busy);
  if (worker && workerQueue.length) {
    const { payload, transfer, resolve, reject } = workerQueue.shift()!;
    (worker as any).busy = true;
    worker.onmessage = (e) => {
      (worker as any).busy = false;
      e.data && e.data.error ? reject(e.data.error) : resolve(e.data);
      workerProcess();
    };
    worker.onerror = (err) => {
      (worker as any).busy = false;
      reject(err);
      workerProcess();
    };
    worker.postMessage(payload, transfer ?? []);
  }
}

export function runWorkerTask(
  payload: any,
  transfer?: Transferable[],
): Promise<any> {
  return new Promise((resolve, reject) => {
    workerQueue.push({ payload, transfer, resolve, reject });
    workerProcess();
  });
}

if (import.meta && (import.meta as any).webpackHot) {
  (import.meta as any).webpackHot.dispose(() => {
    const state: WorkerPoolState | undefined = g[HMR_KEY];
    if (state) {
      state.pool.forEach((w) => { try { w.terminate(); } catch {} });
      delete g[HMR_KEY];
    }
    if (g[Q_KEY]) {
      g[Q_KEY].length = 0;
      delete g[Q_KEY];
    }
  });
}
